export default class ShopTheLook {
	constructor(){
		this.pointClass = 'shop-the-look-page__point'
        this.points = document.querySelectorAll(`.${this.pointClass}`);
        this.productClass = `shop-the-look-page__product`;
        this.products = document.querySelectorAll(`.${this.productClass}`);
        this.quantity = 1;
        this.timeout = setTimeout(() => {

        }, 300);
        clearTimeout(this.timeout);

        for (let i = 0; i < this.points.length; i++) {
            this.points[i].addEventListener('mouseover', (event) => {
                clearTimeout(this.timeout);
                for (const point of this.points) {
                    point.classList.remove(`${this.pointClass}--active`);
                }
                for (const product of this.products) {
                    product.classList.remove(`${this.productClass}--active`);
                }
            	this.points[i].classList.add(`${this.pointClass}--active`);
            	this.products[i].classList.add(`${this.productClass}--active`);
            });

            this.points[i].addEventListener('mouseout', (event) => {
                this.timeout = setTimeout(() => {
                    for (const point of this.points) {
                        point.classList.remove(`${this.pointClass}--active`);
                    }
                    for (const product of this.products) {
                        product.classList.remove(`${this.productClass}--active`);
                    }
                }, 300);
            });

            const thumbs = this.products[i].querySelectorAll('.shop-the-look-page__thumb');
            this.variations = JSON.parse(this.products[i].dataset.product_variations);

            for (let i = 0; i < thumbs.length; i++) {
                const thumb = thumbs[i];
                thumb.addEventListener('mouseover', () => {
                    let parent = thumb.closest('.shop-the-look-page__product');
                    let image = parent.querySelector('.shop-the-look-page__product-image');
                    image.src = thumb.dataset.image;
                    for (let j = 0; j < thumbs.length; j++) {
                        const el = thumbs[j];
                        el.classList.remove('shop-the-look-page__thumb--active');
                    }
                    thumb.classList.add('shop-the-look-page__thumb--active');
                    let color = parent.querySelector('#attribute_pa_color');
                    color.value = thumb.dataset.option;
                    let eventChange = new Event('change');
                    color.dispatchEvent(eventChange);
                });
            }
        }

        for (let i = 0; i < this.products.length; i++) {
            const element = this.products[i];
            let form = element.querySelector('form');
            let color = form.color;
            let size = form.size;
            let quantity = form.quantity;
            this.quantity = form.quantity.value;
            color.addEventListener('change', () => this.GetVariationId(form));
            size.addEventListener('change', () => this.GetVariationId(form));
            quantity.addEventListener('change', () => this.GetVariationId(form));
            let event = new Event('change');
            color.dispatchEvent(event);
        }

        this.active = 0;
    }

    GetVariationId(form){
        let stockByDate = form.querySelector('#stockByDate');
        stockByDate.classList.remove('not-exist');
        let isProductVariation = false;
        let parent = form.closest('.shop-the-look-page__product');
        let variations = JSON.parse(parent.dataset.product_variations);
        let name = parent.querySelector('.shop-the-look-page__product-title');
        let sizeArray = [];
        let priceTag = parent.querySelector('.shop-the-look-page__product-price');
        let color = form.color;
        let size = form.size;
        for (let i = 0; i < variations.length; i++) {
            const variation = variations[i];
            let colorMatch = decodeURI(color.value).indexOf(variation.attributes.attribute_pa_color) >= 0;
            let sizeMatch = decodeURI(size.value).indexOf(variation.attributes.attribute_pa_size) >= 0;
            if (colorMatch && sizeMatch) {
                this.UpdateProductStock( variation, priceTag, form );
                form.variation_id.value = variation.variation_id;
                isProductVariation = true;
                name.textContent = variation.name;
            }
            if (colorMatch) {
                sizeArray.push(decodeURI(variation.attributes.attribute_pa_size));
            }
        }
        if ( ! isProductVariation ) {
            stockByDate.classList.add('not-exist');
            stockByDate.textContent = 'אין וריאציה של מוצר כזה';
            stockByDate.style.opacity = 1;
        }
        for (let i = 0; i < size.options.length; i++) {
            const option = size.options[i];
            option.disabled = false;
            option.hidden = false;
            for (let j = 0; j < sizeArray.length; j++) {
                const sizeValue = sizeArray[j];
                if (option.value == sizeValue) {
                    option.selected = true;
                    break;
                }
                else {
                    option.disabled = true;
                    option.hidden = true;
                }
            }
        }
    }

	AddComaSeparetor( num ) {
        num = num.toLocaleString( 'en-US', { maximumFractionDigits: 2 } );

        let substr  = num.split( '.' );
        let intVal  = String( substr[0] );
        let decimal = substr[1] !== undefined ? String( substr[1] ) : false;

        if ( decimal.length === 1 ) {
            decimal = decimal + '0';
        }

        //num = decimal ? intVal + '<sup>' + decimal + '</sup>' : intVal;

        return intVal;
	}

	UpdateProductStock( variation, priceTag, form ) {
		const self = this;

		jQuery.ajax({
			url: kaza_ajax.url,
			data: {
				action: 'update_product_stock',
				nonce_code: kaza_ajax.nonce,
				variation: variation.variation_id
			},
			type: 'POST',
			beforeSend: function() {
                //NEW TYPE OF PRODUCT (Prprty 14)
                jQuery.ajax({
                    url: kaza_ajax.url,
                    data: {
                        action: 'check_is_simple_product',
                        nonce_code: kaza_ajax.nonce,
                        variation: variation.variation_id
                    },
                    type: 'POST',
                    success: function (res) {
                        let newPrice;
                        let discount = parseInt(kaza_ajax.discount_first_product);
                        let percent_discount = parseFloat(kaza_ajax.percent_discount_first_product);
                        if ( res['data'] ) {
                            priceTag.innerHTML = '<span class="product__price-currency">₪</span>' + self.AddComaSeparetor(variation.display_regular_price);
                        } else {
                            if ( variation.display_price === variation.display_regular_price ) {
                                const clubLabel = ( typeof kaza_ajax !== 'undefined' && kaza_ajax.club_enabled )
                                    ? '<div class="price-for-members"><a href="#club_tooltip">מחיר לחברי מועדון:</a></div>'
                                    : '';
                                newPrice = `
                                <div class="product-price-new">
                                    <div class="product-price-new__regular"><span>מחיר רגיל:</span><span class="product__price-currency">₪</span><span class="product__price-amount">${self.AddComaSeparetor( variation.display_price )}</span></div>
                                    ${clubLabel}
                                    <div class="product-price-new__vat"><span>` + discount + `%:</span><span class="product__price-currency">₪</span><span class="product__price-amount">${self.AddComaSeparetor(variation.display_price / percent_discount )}</span></div>
                                    <div class="product-price-new__sale"><span>או כמוצר שני:</span><span class="product__price-currency">₪</span><span class="product__price-amount">${self.AddComaSeparetor( variation.display_price / 2 )}</span></div>
                                    ` + ( !!variation.is_without_warranty ? '<div class="product-price-new__important-notice product-price-new__important-warning">* פריט זה נמכר ללא אחריות</div>' : '' ) + `
                                </div>
                                `;
                                priceTag.innerHTML = newPrice;
                            } else {
                                priceTag.innerHTML = '<span class="product__price-currency">₪</span>' + self.AddComaSeparetor( variation.display_price ) + '<del style="margin-left: 10px;">' + '<span class="product__price-currency">₪</span>' + '<span class="product__price-amount">' + self.AddComaSeparetor( variation.display_regular_price ) + '</span></del>';
                            }
                        }
                    },
                    complete: function() {
                        priceTag.style.opacity = 1;
                    }
                });
			},
			success: function( res ) {
				self.CheckStock( variation, form );
			}
		});
	}

	CheckStock( variation, form ) {
        let stockByDate = form.querySelector('#stockByDate');

		jQuery.ajax({
			url: kaza_ajax.url,
			data: {
				action: 'kaza_check_product_stock',
				nonce_code: kaza_ajax.nonce,
				variation: variation.variation_id,
				stock: form.quantity.value
			},
			type: 'POST',
			success: function( res ) {
				if ( res.success ) {
					let date = new Date( Date.now() );
					let dateString = date.getFullYear();
					dateString += '-';
					dateString += 10 > date.getMonth() + 1 ? '0' + ( date.getMonth() + 1 ) : date.getMonth + 1;
					dateString += '-';
					dateString += 10 > date.getDate() ? '0' + date.getDate() : date.getDate();

					let niceDate = res.data.replace( /-/g, '/' );

					if ( dateString == res.data ) {
						stockByDate.textContent = 'זמין להספקה מיידית';
					} else {
						stockByDate.textContent = `אספקה בתאריך ${ niceDate }`;
					}
				}
			},
			complete: function() {
				stockByDate.style.opacity = 1;
			}
		});
	}
}
